import React from 'react';

import { Category } from '../../../store/cart-store';

interface ProductMetaProps {
  sku: string;
  category: Category | string;
  aditionalData: any;
}

const ProductMeta: React.FC<ProductMetaProps> = ({ sku, category, aditionalData }) => {
  return (
    <ul className="ps-0 mb-3 list-unstyled">
      <li className="d-flex align-items-center mb-2">
        <span>Categoría:</span>
        <span className="fw-medium text-secondary ms-1">
          {typeof category === 'string' ? category : category.name}
        </span>
      </li>
      <li className="d-flex align-items-center  mb-2">
        <span>Puntos:</span>
        <span className="fw-medium text-secondary ms-1">
          {aditionalData.loyalty_points}
        </span>
      </li>
      <li className="d-flex align-items-center">
        <span>Bonos Influencer:</span>
        <span className="fw-medium text-secondary ms-1">
          {aditionalData.influencer_bonus}
        </span>
      </li>
    </ul>
  );
};

export default ProductMeta;
